export const awsConfig = {
  region: process.env.REACT_APP_AWS_REGION || 'ap-south-1',
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || '',
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || ''
  },
  bucketName: process.env.REACT_APP_S3_BUCKET_NAME || 'internal-report-product-metrics',
  folderPrefix: process.env.REACT_APP_S3_FOLDER_PREFIX || 'EN-GATEWAY/PREDEV/',
  showNetworkLogs: process.env.REACT_APP_SHOW_NETWORK_LOGS === 'true'
}; 